import { Box, FileInput, RadioButtonGroup, Heading, Text, Anchor } from "grommet";
import { ProcessUpload } from "./encoder";
import algorithms from "../prediction/prediction";
import { useEffect } from "react";

export interface ProcessECGComponentProps {
  data: any[];
  setData: (data: any[]) => void;
  selectedModel: any;
  setSelectedModel: (model: any) => void;
  setProgress: (message: any) => void;
}

export function ProcessComponent({ data, setData, selectedModel, setSelectedModel, setProgress }: ProcessECGComponentProps) {
  const processAllFiles = async (fileList: ArrayBuffer[], fileNames: string[]): Promise<any[]> => {
    console.log(fileList);
    return await Promise.all(
      fileList.map(async (file: ArrayBuffer, index: number) => {
        return await ProcessUpload(file, setProgress, fileNames[index]);
      })
    );
  };

  const handleFileChosen = async (file: any): Promise<ArrayBuffer> => {
    return new Promise<ArrayBuffer>((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result as ArrayBuffer);
      };
      fileReader.onerror = reject;
      fileReader.readAsArrayBuffer(file);
    });
  };

  const readAllFiles = async (AllFiles: any): Promise<ArrayBuffer[]> => {
    return await Promise.all(
      AllFiles.map(async (file: any) => {
        const fileContents = await handleFileChosen(file);
        return fileContents;
      })
    );
  };

  const changeHandler = (event: any) => {
    if (event.target.files.length > 0) {
      if (event.target.files.length <= 500) {
        setProgress("Processing...");
        const selectedFiles = event.target.files;
        const fileNames = Array.from(selectedFiles).map((file: any) => file.name);
        readAllFiles(Array.from(selectedFiles)).then(
          (fileList) =>
            processAllFiles(fileList, fileNames).then((keyList) => {
              setData(keyList);
              setProgress("show");
            })
          // .catch(() => setProgress("Invalid file uploaded"))
        );
      } else {
        setProgress("Too many files uploaded (max 500)");
      }
    } else {
      setData([]);
      setSelectedModel({ value: false });
      setProgress("Start by selecting some data");
    }
  };

  const predictAll = async (dataList: any[]) => {
    const dataListWithPrediction = await Promise.all(
      dataList.map(async (row: any) => {
        const probability = await selectedModel.probability(row.Encoding);

        return {
          ...row,
          Probability: probability,
        };
      })
    );
    setData(dataListWithPrediction);
  };

  useEffect(() => {
    predictAll(data);
  }, [selectedModel]);

  return (
    <Box gap="medium">
      <Heading level={4} margin="none">
        Select your ECG files
      </Heading>
      <Text>
        The tool can be used to convert General Electric (GE) MUSE XML-files, containing the raw data of 12-lead ECGs, into their respective
        FactorECGs. These ECG factors can subsequently be used in your own models for training, or you can use one of the provided models
        for validation. Note that the ECGs are completely anonymized before processing and no patient data is uploaded. A maximum of 500
        ECGs can be uploaded every time. Please report any issues with the tool{" "}
        <Anchor href="https://github.com/rutgervandeleur/ecgxai/issues">here</Anchor>.
      </Text>
      <FileInput
        name="file"
        onChange={changeHandler}
        maxSize={1000000}
        multiple={{
          aggregateThreshold: 1,
          max: 500,
        }}
      />
      <Heading level={4} margin={{ top: "small", bottom: "none" }}>
        Choose an algorithm to run on the files (optionally)
      </Heading>
      <RadioButtonGroup
        disabled={data.length > 0 ? false : true}
        name="modelSelection"
        options={algorithms}
        value={selectedModel.value}
        onChange={(event: any) => {
          setSelectedModel(algorithms.find((x) => x.value === event.target.value));
        }}
      />
    </Box>
  );
}
